// extracted by mini-css-extract-plugin
module.exports = {"cmsEditMode":"CmsEditSwitch_cmsEditMode__1vQOk","cmsEditModeMobile":"CmsEditSwitch_cmsEditModeMobile__10S23"};